<template>
<div class="row">
    <div class="col-12">
        <div class="form-group col-sm-3">
            <label>Zgjedhni vitin:</label>
            <select class="custom-select" v-model="selected" @change="onChange($event)">
                
                <option class="" v-for="item in vitet" :value=item> {{item}}</option>
            </select>
        </div>
        <card>
            <div slot="raw-content" class="table-responsive">
                <!-- Zgjedhja e provimeve per tu paraqitur -->
                <table class="table table-striped table-hover">
                    <div class="text-center" v-if="loader">
                        <div class="spinner-border" role="status">
                            <span class="visually-hidden"></span>
                        </div>
                    </div>
                    <thead>
                        <tr>
                            <th>L&#235;nda</th>
                            <th>Ligj&#235;ruesi</th>
                            <th>Viti</th>
                            <th>Obligative</th>
                            <th>ECTS</th>
                            <th>Kohëzgjatja</th>
                            <th>Semestri</th>
                            <th>Fondi</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="i in planprogrami" :key="i.afatiID">
                            <td>{{i.lenda}}</td>
                            <td>{{ i.profesori_me_Titull}}</td>
                            <td>{{ i.vitittxt}}</td>
                            <td>{{ i.obligative}}</td>
                            <td>{{ i.ectS_Kredite}}</td>
                            <td>{{ i.kohezgjatja}}</td>
                            <td>{{ i.semestri}}</td>
                            <td>{{ i.fondi_i_oreve}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </card>
    </div>
</div>
</template>

<script>
import { APISettings } from '../api/config.js'
import { PaperTable } from "@/components";

const tableColumns = ["Lënda", "Ligjëruesi", "Viti", "Obligative", "ECTS", "Kohëzgjatja", "Semestri", "Fondi"];
const tableData = [];

export default {
    components: {
        PaperTable,
    },
    data() {
        return {
            table1: {
                title: "Planprogrami",
                subTitle: "Here is a subtitle for this table",
                columns: [...tableColumns],
                data: [...tableData],
            },
            vitet: ["Viti I", "Viti II", "Viti III", "Viti IV"],
            test: "",
            selected: ["Viti I"],
            selectAll: false,
            planprogrami: [],
            loader: false,
        };
    },

    methods: {
        getPlanprogrami() {
            this.loader = true;
            var get_token = this.$cookies.get("accesstoken");

            fetch(APISettings.baseURL + `Lendet/getPlanprogrami/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + get_token
                    },
                })
                .then(
                    (signinResponse) => {
                        signinResponse.json().then((res) => {
                            this.planprogrami = [];
                            if (signinResponse.status === 200) {
                                res.forEach(obj => {
                                    if (this.selected == obj.vitittxt) {
                                        this.planprogrami.push(obj);
                                    } else if (this.selected == obj.vitittxt) {
                                        this.planprogrami.push(obj);
                                    } else if (this.selected == obj.vitittxt) {
                                        this.planprogrami.push(obj);
                                    } else if (this.selected == obj.vitittxt) {
                                        this.planprogrami.push(obj);
                                    }
                                });
                            } else if (signinResponse.status === 400) {
                                console.log("ERROR DATA1");
                            }
                            this.loader = false;
                        })
                    }).catch(error => {
                    console.log("ERROR DATA2");
                })
        },
        onChange(event) {
            this.test = event.target.value;
            this.getPlanprogrami();
        },
    },
    beforeMount() {
        this.getPlanprogrami();
    },

};
</script>

<style></style>
